module.exports = "<div class=\"LedContainer\">\r\n    <div class=\"ColorContainer\">\r\n        <div class=\"ColorBox\" [style.background-color]=\"color\" [style.opacity]=\"_opacity\" [style.-webkit-transition]=\"transition\"></div>\r\n    </div>\r\n    <div class=\"SliderContainer\">\r\n        {{Opacity / 2.55 | number : '1.0-0'}}\r\n        <input type=\"range\" min=\"0\" max=\"255\" step=\"1\" [disabled]=\"_IsPlaying\" [(ngModel)]=\"Opacity\" />\r\n    </div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/Components/LedFaded/LedFaded.component.html
 ** module id = 41
 ** module chunks = 0
 **/